import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
 * @typedef {import('@azure/msal-browser').RedirectRequest} RedirectRequest
 */
import * as microsoftTeams from "@microsoft/teams-js";
import * as msal from '@azure/msal-browser';
import axios from 'axios';
import getEnvironment from 'lib/env';
import moment from 'moment';
import store from '../index';
import DateTime from '_class/DateTime';
import { appInsights } from 'lib/appInsights';
/**
 * @typedef {Object} MSALConfig MSAL Config model
 */

var msalConfig = {
  auth: {
    clientId: getEnvironment().clientId,
    authority: 'https://login.microsoftonline.com/common/',
    postLogoutRedirectUri: window.location.origin + '/',
    redirectUri: window.location.origin + '/',
    navigateToLoginRequestUrl: false
  },
  cache: {
    // TODO: Decide if we should use sessionStorage (default) or localStorage here
    // localStorage seems to work better for our use case
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true
  }
};
console.log('_env', getEnvironment());
/**
 * @type {RedirectRequest} loginRequest
 */

var loginRequest = {
  scopes: ["openid", "profile", "offline_access"]
};
/**
 * @type {Array} graphScopes
 */

var graphScopes = ["Files.ReadWrite.All"];
var instance = new msal.PublicClientApplication(msalConfig);

var _addToast = function _addToast(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';
  var error = {
    translateMsg: message,
    type: type,
    target: 'API',
    time: new DateTime()
  };
  store.dispatch({
    type: 'ADD_ERROR',
    payload: error
  });
};

var requirePopupConsent = function requirePopupConsent(clientId, redirectUri, scopes) {
  var knownClientApplications = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
      var msalCustomConfig, msalClient, customRequest;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              msalCustomConfig = {
                auth: {
                  clientId: clientId,
                  authority: 'https://login.microsoftonline.com/common/',
                  postLogoutRedirectUri: window.location.origin + '/',
                  redirectUri: window.location.origin + redirectUri,
                  navigateToLoginRequestUrl: false
                },
                cache: {
                  // TODO: Decide if we should use sessionStorage (default) or localStorage here
                  // localStorage seems to work better for our use case
                  cacheLocation: "localStorage",
                  storeAuthStateInCookie: false
                }
              };
              msalClient = new msal.PublicClientApplication(msalCustomConfig);
              customRequest = {
                scopes: scopes
              };
              customRequest.account = getUser();
              msalClient.acquireTokenSilent(customRequest).then(function (response) {
                resolve(response);
              })["catch"](function (error) {
                msalClient.acquireTokenPopup(customRequest).then(function (token) {
                  resolve(token);
                })["catch"](function (error) {
                  reject(error);
                });
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var isIframe = function isIframe() {
  try {
    return window.self !== window.top || window.navigator.userAgent.indexOf('TeamsMobile') > -1;
  } catch (e) {
    return true;
  }
};

var getToken = function getToken(request) {
  return new Promise( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resolve, reject) {
      var token;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              request.account = getUser();

              if (!microsoftTeams.app.isInitialized()) {
                _context4.next = 5;
                break;
              }

              microsoftTeams.authentication.getAuthToken().then(function (token) {
                resolve({
                  accessToken: token
                });
              })["catch"](function (error) {
                appInsights.trackTrace({
                  message: "EDU005 | Teams SDK - getAuthToken fails"
                }, error);
                console.log(error);
                reject('Failed to retrieve token from Teams SDK');
              });
              _context4.next = 12;
              break;

            case 5:
              if (!(instance.getAllAccounts().length == 0)) {
                _context4.next = 8;
                break;
              }

              reject('User not logged in');
              return _context4.abrupt("return", true);

            case 8:
              _context4.next = 10;
              return new Promise( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolveToken, rejectToken) {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          instance.acquireTokenSilent(request).then(function (token) {
                            resolveToken(token);
                          })["catch"]( /*#__PURE__*/function () {
                            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(error) {
                              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                while (1) {
                                  switch (_context2.prev = _context2.next) {
                                    case 0:
                                      appInsights.trackTrace({
                                        message: "EDU005 | MSAL - AcquireTokenSilent fails (step 503)"
                                      }, error);
                                      resolveToken(null);

                                    case 2:
                                    case "end":
                                      return _context2.stop();
                                  }
                                }
                              }, _callee2);
                            }));

                            return function (_x7) {
                              return _ref4.apply(this, arguments);
                            };
                          }());

                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x5, _x6) {
                  return _ref3.apply(this, arguments);
                };
              }())["catch"](function (error) {
                console.log("error catch", error);
                reject(error);
              });

            case 10:
              token = _context4.sent;
              resolve(token);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
};

var getSchoolId = function getSchoolId() {
  return new Promise( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resolve, reject) {
      var account, id;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (microsoftTeams.app.isInitialized()) {
                microsoftTeams.app.getContext().then(function (context) {
                  resolve(localStorage.getItem('hal.school' + context.user.id));
                });
              } else {
                if (instance.getAllAccounts().length > 0) {
                  account = getUser();

                  if (account != null) {
                    id = account.homeAccountId.split('.')[0];
                    resolve(localStorage.getItem('hal.school' + id));
                  }
                }
              }

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }());
};

var tokenErrorCallbacks = [];

var onMsalTokenError = function onMsalTokenError(callback) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (callback != null) {
    tokenErrorCallbacks.push(callback);
    return true;
  }

  tokenErrorCallbacks.forEach(function (callback) {
    if (callback != null && typeof callback == 'function') {
      callback.apply(void 0, args);
    }
  });
};

var loginRequiredCallbacks = [];

var onMsalLoginRequired = function onMsalLoginRequired(callback) {
  return new Promise(function (resolve) {
    console.log("msalLoginRequired", callback);

    if (callback != null) {
      loginRequiredCallbacks.push(callback);
      resolve(true);
      return true;
    }

    var promises = [];
    loginRequiredCallbacks.forEach(function (callback) {
      if (callback != null) {
        var promise = callback();
        promises.push(promise);
        return true;
      }
    });
    Promise.all(promises).then(function () {
      resolve(1);
    });
  });
};

var getUser = function getUser() {
  if (isIframe()) {
    return localStorage.getItem('session.username');
  } else {
    if (instance.getAllAccounts().length > 0) {
      var username = localStorage.getItem('session.username');

      if (username != null) {
        return instance.getAllAccounts().find(function (account) {
          return account.username == username;
        });
      } else {
        return instance.getAllAccounts()[0];
      }
    }
  }

  return null;
};

var setUser = function setUser(username) {
  localStorage.setItem('session.username', username);
};

var getUserId = function getUserId() {
  var user = getUser();

  if (user != null) {
    if (user.homeAccountId.indexOf('.') > -1) {
      return user.homeAccountId.split('.')[0];
    }

    return user.homeAccountId;
  }

  return null;
};

var http = axios.create({
  baseURL: getEnvironment().baseURL
});
var errors = {
  AuthError: msal.AuthError,
  AuthErrorMessage: msal.AuthErrorMessage,
  BrowserAuthError: msal.BrowserAuthError,
  BrowserAuthErrorMessage: msal.BrowserAuthErrorMessage,
  BrowserConfigurationAuthError: msal.BrowserConfigurationAuthError,
  BrowserConfigurationAuthErrorMessage: msal.BrowserConfigurationAuthErrorMessage,
  InteractionRequiredAuthError: msal.InteractionRequiredAuthError
};

var clearInteractionProgress = function clearInteractionProgress() {
  if (document.cookie.indexOf('interaction_in_progress') > -1 || document.cookie.indexOf('interaction.status') > -1) {
    document.cookie.split(";").forEach(function (c) {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
  }

  Object.keys(sessionStorage).forEach(function (key) {
    if (key.indexOf('interaction.status') > -1) {
      sessionStorage.removeItem(key);
    }
  });
  Object.keys(localStorage).forEach(function (key) {
    if (key.indexOf('interaction.status') > -1) {
      localStorage.removeItem(key);
    }
  });
};

http.interceptors.request.use(function (config) {
  return new Promise( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(resolve, reject) {
      var _config$headers;

      var request, token, lcid, currentSchool;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              request = _objectSpread({}, loginRequest);

              if (config.url.indexOf('graph.microsoft.com') > -1) {
                // Add scopes for MS Graph
                request.scopes = [].concat(graphScopes, _toConsumableArray(request.scopes));
              } else {
                // Add scopes for environment
                request.scopes = [].concat(_toConsumableArray(getEnvironment().scopes), _toConsumableArray(request.scopes));
              }

              _context6.next = 4;
              return getToken(request);

            case 4:
              token = _context6.sent;
              lcid = localStorage.getItem('language');
              _context6.next = 8;
              return getSchoolId();

            case 8:
              currentSchool = _context6.sent;

              if (currentSchool != null) {
                if (config.params == null) {
                  config.params = {};
                }

                config.params['SchoolId'] = currentSchool;
              }

              if (lcid != null) {
                if (config.params == null) {
                  config.params = {};
                }

                config.params['lcid'] = lcid;
              }

              if (token != null && ((_config$headers = config.headers) === null || _config$headers === void 0 ? void 0 : _config$headers.Authorization) == null) {
                config.headers.common['Authorization'] = "Bearer " + token.accessToken;
              } // TODO: Reject promise if something goes wrong with fetching token


              resolve(config);

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x10, _x11) {
      return _ref6.apply(this, arguments);
    };
  }());
}, function (error) {
  return Promise.reject(error);
});
http.interceptors.response.use(function (response) {
  if (response.status == 204) {
    response.data = null;
  }

  return response;
}, /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(error) {
    var _error$response, _error$config, _error$config2, _error$config3, _error$config4, _error$config5, _error$response2, _error$config6, _error$config7, _error$config8, _error$config9, _error$config10;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            console.log("ERROR", error);

            if (!(error == null || error.response == null)) {
              _context7.next = 3;
              break;
            }

            return _context7.abrupt("return", Promise.reject(error));

          case 3:
            if (!(error.response.status == 401)) {
              _context7.next = 6;
              break;
            }

            console.log("ERROR REQUEST ", error);
            return _context7.abrupt("return", onMsalLoginRequired().then(function (result) {
              return http.request(error.config);
            }));

          case 6:
            if (!(error.response.status == 403)) {
              _context7.next = 10;
              break;
            }

            appInsights.trackTrace({
              message: "EDU021 | MSAL lib interceptor got status 403"
            }, {
              data: error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data,
              params: error === null || error === void 0 ? void 0 : (_error$config = error.config) === null || _error$config === void 0 ? void 0 : _error$config.params,
              url: error === null || error === void 0 ? void 0 : (_error$config2 = error.config) === null || _error$config2 === void 0 ? void 0 : _error$config2.url,
              method: error === null || error === void 0 ? void 0 : (_error$config3 = error.config) === null || _error$config3 === void 0 ? void 0 : _error$config3.method,
              baseURL: error === null || error === void 0 ? void 0 : (_error$config4 = error.config) === null || _error$config4 === void 0 ? void 0 : _error$config4.baseURL,
              schoolId: error === null || error === void 0 ? void 0 : (_error$config5 = error.config) === null || _error$config5 === void 0 ? void 0 : _error$config5.params['SchoolId']
            }); // Dispatch an error (toast bar)

            _addToast("You don't seem to have permission to perform this action. For support, contact your school administrator.", 'error');

            return _context7.abrupt("return", Promise.reject(error));

          case 10:
            if (!(error.response.status == 0)) {
              _context7.next = 18;
              break;
            }

            appInsights.trackTrace({
              message: "EDU020 | MSAL lib interceptor got status 0"
            }, {
              data: error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data,
              params: error === null || error === void 0 ? void 0 : (_error$config6 = error.config) === null || _error$config6 === void 0 ? void 0 : _error$config6.params,
              url: error === null || error === void 0 ? void 0 : (_error$config7 = error.config) === null || _error$config7 === void 0 ? void 0 : _error$config7.url,
              method: error === null || error === void 0 ? void 0 : (_error$config8 = error.config) === null || _error$config8 === void 0 ? void 0 : _error$config8.method,
              baseURL: error === null || error === void 0 ? void 0 : (_error$config9 = error.config) === null || _error$config9 === void 0 ? void 0 : _error$config9.baseURL,
              schoolId: error === null || error === void 0 ? void 0 : (_error$config10 = error.config) === null || _error$config10 === void 0 ? void 0 : _error$config10.params['SchoolId']
            }); // Wait 1 second before trying again

            _context7.next = 14;
            return new Promise(function (resolve) {
              setTimeout(function () {
                return resolve(1);
              }, 1000);
            });

          case 14:
            // Save or update number of tries in HTTP headers
            if (error.config.headers['Retries'] == null) {
              // Dispatch an error (toast bar) first retry
              _addToast("You seem to have lost connection to the server. You can keep working as usual while we're trying to reconnect you.");

              error.config.headers['Retries'] = '1';
            } else {
              error.config.headers['Retries'] = parseInt(error.config.headers['Retries']) + 1 + '';
            }

            if (!(parseInt(error.config.headers['Retries']) > 49)) {
              _context7.next = 17;
              break;
            }

            return _context7.abrupt("return", Promise.reject(error));

          case 17:
            return _context7.abrupt("return", http.request(error.config));

          case 18:
            return _context7.abrupt("return", Promise.reject(error));

          case 19:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function (_x12) {
    return _ref7.apply(this, arguments);
  };
}()); // Export members of msal.js

export { loginRequest, getToken, http, getUser, setUser, getUserId, requirePopupConsent, errors, onMsalTokenError, onMsalLoginRequired, clearInteractionProgress }; // Export MSAL instance

export default instance;